import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5edc82f5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "activity-create-box"
};
const _hoisted_3 = {
  class: "headline"
};
const _hoisted_4 = {
  class: "activity-left-area"
};
const _hoisted_5 = {
  class: "activityNameItem"
};
const _hoisted_6 = {
  class: "lable"
};
const _hoisted_7 = {
  class: "activityNameItem"
};
const _hoisted_8 = {
  class: "lable"
};
const _hoisted_9 = {
  class: "activityNameItem",
  style: {
    "align-items": "flex-start"
  }
};
const _hoisted_10 = {
  class: "lable"
};
const _hoisted_11 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "width": "100%",
    "height": "100%"
  }
};
const _hoisted_12 = {
  class: "logo-upload-icon-box"
};
const _hoisted_13 = {
  class: "logo-upload-icon-text"
};
const _hoisted_14 = {
  class: "uploadImageBox"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "text"
};
const _hoisted_17 = {
  class: "activityNameItem"
};
const _hoisted_18 = {
  class: "lable"
};
const _hoisted_19 = {
  class: "activityNameItem"
};
const _hoisted_20 = {
  class: "lable"
};
const _hoisted_21 = {
  class: "activity-right-area"
};
const _hoisted_22 = {
  style: {
    "flex": "1",
    "overflow-y": "auto",
    "margin-right": "20px"
  }
};
const _hoisted_23 = {
  class: "headline"
};
const _hoisted_24 = {
  class: "upload-box"
};
const _hoisted_25 = {
  class: "upload-box-title"
};
const _hoisted_26 = {
  class: "upload-box-title-text"
};
const _hoisted_27 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_28 = {
  class: "upload-box-dashed"
};
const _hoisted_29 = {
  class: "upload-icon-group-box"
};
const _hoisted_30 = {
  class: "el-upload__text"
};
const _hoisted_31 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "justify-content": "flex-start",
    "flex-wrap": "wrap"
  }
};
const _hoisted_33 = {
  class: "headline"
};
const _hoisted_34 = {
  class: "manager-add-box"
};
const _hoisted_35 = {
  class: "lable"
};
const _hoisted_36 = {
  style: {
    "display": "flex",
    "margin-top": "30px",
    "align-items": "center",
    "margin-bottom": "30px"
  }
};
const _hoisted_37 = {
  class: "managers-title"
};
const _hoisted_38 = {
  class: "person-in-charge-label label"
};
const _hoisted_39 = {
  class: "person-in-charge-label label",
  style: {
    "margin-left": "30px"
  }
};
const _hoisted_40 = {
  class: "headline"
};
const _hoisted_41 = {
  class: "person-in-charge-label label"
};
const _hoisted_42 = {
  class: "headline"
};
const _hoisted_43 = {
  style: {
    "margin-top": "30px",
    "display": "flex",
    "justify-content": "end",
    "margin-bottom": "30px"
  }
};
const _hoisted_44 = {
  style: {
    "height": "230px",
    "width": "100%",
    "margin-top": "10px"
  }
};
const _hoisted_45 = {
  style: {
    "font-size": "24px"
  }
};
const _hoisted_46 = {
  style: {
    "margin-left": "8px"
  }
};
const _hoisted_47 = {
  style: {
    "display": "flex",
    "padding": "20px 0px"
  }
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_49 = {
  class: "ex-dialog-title"
};
const _hoisted_50 = {
  style: {
    "width": "100%",
    "height": "432px"
  }
};
const _hoisted_51 = {
  style: {
    "display": "flex",
    "justify-content": "end",
    "padding": "20px 0px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_range_picker = _resolveComponent("a-range-picker");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_button = _resolveComponent("a-button");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_folder_card = _resolveComponent("folder-card");
  const _component_a_tree_select = _resolveComponent("a-tree-select");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_el_form = _resolveComponent("el-form");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_vxe_checkbox = _resolveComponent("vxe-checkbox");
  const _component_ex_dialog = _resolveComponent("ex-dialog");
  const _component_vue_cropper = _resolveComponent("vue-cropper");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("activityCreate.basicInfo")), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_form, {
    model: _ctx.activityData.activityFormData,
    ref: "activityForm",
    "show-message": false,
    hideRequiredMark: true,
    "label-width": "0px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("activityCreate.activityName")) + ":", 1), _createVNode(_component_a_select, {
      value: _ctx.activityData.activityFormData.activityWeekId,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.activityData.activityFormData.activityWeekId = $event),
      placeholder: _ctx.$t('activityCreate.select'),
      size: "middle",
      style: {
        "width": "125px",
        "height": "39px",
        "margin-right": "19px"
      }
    }, {
      suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
        class: "ant-select-suffix",
        style: {
          "color": "#818181"
        }
      })]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.activityWeekList, (item, index) => {
        return _openBlock(), _createBlock(_component_a_select_option, {
          key: index,
          value: item.activityWeekId
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.activityWeekName), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["value", "placeholder"]), _createVNode(_component_a_select, {
      value: _ctx.activityData.activityFormData.activityYear,
      "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.activityData.activityFormData.activityYear = $event),
      placeholder: _ctx.$t('activityCreate.select'),
      size: "middle",
      style: {
        "width": "125px",
        "height": "39px",
        "margin-right": "19px"
      }
    }, {
      suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
        class: "ant-select-suffix",
        style: {
          "color": "#818181"
        }
      })]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.yearsArray, (item, index) => {
        return _openBlock(), _createBlock(_component_a_select_option, {
          key: index,
          value: item
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["value", "placeholder"]), _createVNode(_component_a_input, {
      class: "activity-name",
      placeholder: _ctx.$t('activityCreate.enterActivityName'),
      style: {
        "width": "256px",
        "height": "39px",
        "font-size": "12px"
      },
      value: _ctx.activityData.activityFormData.activityName,
      "onUpdate:value": _cache[2] || (_cache[2] = $event => _ctx.activityData.activityFormData.activityName = $event)
    }, null, 8, ["placeholder", "value"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("activityCreate.activityTime")) + ":", 1), _createVNode(_component_a_range_picker, {
      value: _ctx.activityData.activityFormData.activityDateValue,
      "onUpdate:value": _cache[3] || (_cache[3] = $event => _ctx.activityData.activityFormData.activityDateValue = $event),
      format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
      placeholder: [_ctx.$t('activityCreate.startTime'), _ctx.$t('activityCreate.endTime')],
      valueFormat: "YYYY-MM-DD",
      style: {
        "width": "265px"
      }
    }, {
      suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
        class: "ant-select-suffix",
        style: {
          "color": "#818181",
          "font-size": "24px"
        }
      })]),
      _: 1
    }, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("activityCreate.activityImage")) + ":", 1), _createVNode(_component_el_upload, {
      class: "logo-upload-box",
      drag: "",
      accept: "image/png, image/jpeg, image/gif, image/jpg",
      ref: "uploadActivityLogo",
      "show-file-list": false,
      action: _ctx.uploadActivityLogoData.signatureData.host,
      "before-upload": _ctx.handleActivityLogoBeforeUpload,
      "on-success": _ctx.handleActivityLogoOnSuccess,
      data: _ctx.uploadActivityLogoData.data,
      "on-exceed": _ctx.handleActivityLogoExceed,
      "on-change": _ctx.handleActivityLogoOnChange,
      limit: 1,
      "auto-upload": false,
      "file-list": _ctx.uploadActivityLogoData.fileList
    }, {
      default: _withCtx(() => [_ctx.uploadActivityLogoData.file.url === null ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_svg_icon, {
        iconName: "tk_plus",
        iconColor: '#d3d3d3',
        iconSize: "18px"
      }), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("activityCreate.clickUploadAddImage")), 1)])])) : _createCommentVNode("", true), _ctx.uploadActivityLogoData.file.url !== null ? (_openBlock(), _createBlock(_component_el_image, {
        key: 1,
        style: {
          "flex": "1",
          "cursor": "pointer"
        },
        src: _ctx.uploadActivityLogoData.file.url
      }, null, 8, ["src"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["action", "before-upload", "on-success", "data", "on-exceed", "on-change", "file-list"]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("activityCreate.tips")), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("activityCreate.imageSizeFormat")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("activityCreate.imageMaxSize")), 1)])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("activityCreate.activityCategory")) + ": ", 1), _createVNode(_component_a_select, {
      value: _ctx.activityData.activityFormData.activityCategoryId,
      "onUpdate:value": _cache[4] || (_cache[4] = $event => _ctx.activityData.activityFormData.activityCategoryId = $event),
      placeholder: _ctx.$t('activityCreate.select'),
      size: "middle",
      style: {
        "width": "125px",
        "height": "39px",
        "margin-right": "19px"
      }
    }, {
      suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
        class: "ant-select-suffix",
        style: {
          "color": "#818181"
        }
      })]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.activityCategoryList, (item, index) => {
        return _openBlock(), _createBlock(_component_a_select_option, {
          key: index,
          value: item.activityCategoryId
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.activityCategoryName), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("activityCreate.activityTag")) + ":", 1), _createVNode(_component_a_select, {
      value: _ctx.activityData.activityFormData.activityTags,
      "onUpdate:value": _cache[5] || (_cache[5] = $event => _ctx.activityData.activityFormData.activityTags = $event),
      mode: "multiple",
      "allow-clear": "",
      placeholder: _ctx.$t('activityCreate.select'),
      size: "middle",
      style: {
        "width": "540px",
        "height": "39px",
        "margin-right": "19px"
      },
      dropdownMatchSelectWidth: false,
      showArrow: true
    }, {
      suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
        class: "ant-select-suffix",
        style: {
          "color": "#818181"
        }
      })]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.activityTagData, (item, index) => {
        return _openBlock(), _createBlock(_component_a_select_option, {
          key: index,
          value: item.activityTagId
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.activityTagNameZh), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["value", "placeholder"]), _ctx.permission.havePermission('活动管理', '标签管理') ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      onClick: _ctx.oepnTagEditDialog,
      iconName: "setup",
      iconColor: '#E5E9F2',
      iconSize: "20px"
    }, null, 8, ["onClick"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_form, {
    model: _ctx.activityData.activityFormData,
    "show-message": false,
    "label-width": "0px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("activityCreate.activityFileManagement")), 1), _ctx.permission.havePermission('活动管理', '活动文件管理') ? (_openBlock(), _createBlock(_component_el_popover, {
      key: 0,
      visible: _ctx.uploadFilePopoverVisible,
      placement: "bottom",
      trigger: "click",
      width: "auto",
      teleported: false,
      "popper-class": "upload-box-popper"
    }, {
      reference: _withCtx(() => [_createVNode(_component_a_button, {
        onClick: _ctx.openUploadFilePopover,
        class: "sts-button default",
        color: "black",
        style: {
          "margin": "30px 0"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.fileUpload")), 1)]),
        _: 1
      }, 8, ["onClick"])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("activityCreate.fileUpload")), 1), _createVNode(_component_svg_icon, {
        iconName: "close",
        iconColor: 'black',
        iconSize: "15px",
        style: {
          "cursor": "pointer",
          "padding": "3px"
        },
        onClick: _cache[6] || (_cache[6] = $event => _ctx.uploadFilePopoverVisible = false)
      })]), _createVNode(_component_el_upload, {
        "on-exceed": _ctx.handleFileExceed,
        class: "upload-pane",
        drag: "",
        ref: "uploadFile",
        action: _ctx.uploadFileData.signatureData.host,
        "before-upload": _ctx.handleFileBeforeUpload,
        "on-success": _ctx.handleFileOnSuccess,
        data: _ctx.uploadFileData.data,
        limit: 1,
        "file-list": _ctx.uploadFileData.fileList
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createVNode(_component_a_button, {
          class: "sts-button default",
          color: "#539ce0",
          style: {
            "width": "100px",
            "margin": "5px 0px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.browse")), 1)]),
          _: 1
        }), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_svg_icon, {
          iconName: "Excel",
          iconSize: "18px"
        }), _createVNode(_component_svg_icon, {
          iconName: "upload",
          iconSize: "18px"
        })]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityCreate.clickOrDragUpload")), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("activityCreate.supportFileType")), 1)])])])]),
        _: 1
      }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
      _: 1
    }, 8, ["visible"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.uploadFiles, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "width": "30%"
        },
        key: index
      }, [_createVNode(_component_folder_card, {
        "file-name": item.fileName,
        "file-date": item.date,
        url: item.uploadedOssName,
        onRemove: $event => _ctx.removeFile(item)
      }, null, 8, ["file-name", "file-date", "url", "onRemove"])]);
    }), 128))]), _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("activityCreate.responsiblePersonManagement")), 1), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("activityCreate.responsibleOrganization")), 1), _createVNode(_component_a_tree_select, {
      value: _ctx.activityData.selectedOrganizationId,
      "onUpdate:value": _cache[7] || (_cache[7] = $event => _ctx.activityData.selectedOrganizationId = $event),
      treeData: _ctx.activityData.organizationTreeData,
      treeDefaultExpandAll: true,
      fieldNames: {
        label: 'organizationName',
        value: 'organizationId',
        children: 'children'
      },
      showSearch: "",
      placeholder: _ctx.$t('activityCreate.selectOrganization'),
      style: {
        "width": "200px"
      }
    }, {
      suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
        class: "ant-select-suffix"
      })]),
      _: 1
    }, 8, ["value", "treeData", "placeholder"]), _createVNode(_component_a_button, {
      onClick: _cache[8] || (_cache[8] = $event => _ctx.addOrganizationManagersClick()),
      style: {
        "margin-left": "13px"
      },
      class: "sts-button default",
      circle: ""
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.add")), 1)]),
      _: 1
    })]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.activityFormData.activityManagers, (activityManagers, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(activityManagers.organizationName) + _toDisplayString(_ctx.$t("activityCreate.responsiblePerson")), 1), _createVNode(_component_a_button, {
        onClick: $event => _ctx.decreaseOrganizationManagersClick(activityManagers),
        style: {
          "margin-left": "13px"
        },
        class: "sts-button default",
        circle: ""
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.delete")), 1)]),
        _: 2
      }, 1032, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityManagers.users, (user, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "person-in-item-box"
        }, [_createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("activityCreate.name")) + ": ", 1), _createVNode(_component_a_form_item, {
          name: "userId"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: user.userId,
            "onUpdate:value": $event => user.userId = $event,
            "allow-clear": "",
            placeholder: _ctx.$t('activityCreate.select'),
            size: "middle",
            style: {
              "width": "195px",
              "height": "39px",
              "font-size": "12px",
              "margin-bottom": "0"
            }
          }, {
            suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
              class: "ant-select-suffix",
              style: {
                "color": "#818181"
              }
            })]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityManagers.userData, (item, index) => {
              return _openBlock(), _createBlock(_component_a_select_option, {
                key: index,
                value: item.id
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["value"]);
            }), 128))]),
            _: 2
          }, 1032, ["value", "onUpdate:value", "placeholder"])]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("activityCreate.responsibleSection")) + ": ", 1), _createVNode(_component_a_form_item, {
          name: "managedArea"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            placeholder: _ctx.$t('activityCreate.enter'),
            style: {
              "width": "195px",
              "height": "39px",
              "font-size": "12px",
              "margin-bottom": "0"
            },
            value: user.managedArea,
            "onUpdate:value": $event => user.managedArea = $event
          }, null, 8, ["placeholder", "value", "onUpdate:value"])]),
          _: 2
        }, 1024), index == activityManagers.users.length - 1 ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          onClick: $event => _ctx.addManagersClick(activityManagers.users),
          style: {
            "margin-left": "13px"
          },
          class: "sts-button default",
          circle: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.add")), 1)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
          onClick: $event => _ctx.decreaseManagersClick(activityManagers, user),
          style: {
            "margin-left": "13px"
          },
          class: "sts-button default",
          circle: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.delete")), 1)]),
          _: 2
        }, 1032, ["onClick"])]);
      }), 128))]);
    }), 128)), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("activityCreate.supplierManagement")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.activityFormData.activityVendors, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "person-in-item-box",
        style: {
          "margin-top": "30px"
        }
      }, [_createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("activityCreate.addSupplier")) + ": ", 1), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_a_select, {
          value: item.vendorTypeId,
          "onUpdate:value": $event => item.vendorTypeId = $event,
          "allow-clear": "",
          onChange: $event => _ctx.vendorTypeChange(item),
          placeholder: _ctx.$t('activityCreate.select'),
          size: "middle",
          style: {
            "width": "195px",
            "height": "39px",
            "font-size": "12px",
            "margin-bottom": "0"
          }
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
            class: "ant-select-suffix",
            style: {
              "color": "#818181"
            }
          })]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.vendorTypeVendorData, (msg, idx) => {
            return _openBlock(), _createBlock(_component_a_select_option, {
              key: idx,
              value: msg.vendorTypeId
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(msg.vendorTypeNameZh), 1)]),
              _: 2
            }, 1032, ["value"]);
          }), 128))]),
          _: 2
        }, 1032, ["value", "onUpdate:value", "onChange", "placeholder"])]),
        _: 2
      }, 1024), _createVNode(_component_el_form_item, {
        style: {
          "margin-left": "30px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_select, {
          value: item.vendorId,
          "onUpdate:value": $event => item.vendorId = $event,
          "allow-clear": "",
          placeholder: _ctx.$t('activityCreate.select'),
          size: "middle",
          style: {
            "width": "195px",
            "height": "39px",
            "font-size": "12px",
            "margin-bottom": "0"
          }
        }, {
          suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
            class: "ant-select-suffix",
            style: {
              "color": "#818181"
            }
          })]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.vendorData, (msg, idx) => {
            return _openBlock(), _createBlock(_component_a_select_option, {
              key: idx,
              value: msg.vendorId
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(msg.vendorName), 1)]),
              _: 2
            }, 1032, ["value"]);
          }), 128))]),
          _: 2
        }, 1032, ["value", "onUpdate:value", "placeholder"])]),
        _: 2
      }, 1024), index == _ctx.activityData.activityFormData.activityVendors.length - 1 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: _ctx.addVendorClick,
        class: "sts-button default",
        style: {
          "margin-left": "13px"
        },
        circle: ""
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.add")), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
        onClick: $event => _ctx.decreaseVendorClick(item),
        class: "sts-button default",
        style: {
          "margin-left": "13px"
        },
        circle: ""
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.delete")), 1)]),
        _: 2
      }, 1032, ["onClick"])]);
    }), 128)), _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("activityCreate.remark")), 1), _createVNode(_component_a_textarea, {
      value: _ctx.activityData.activityFormData.activityDescription,
      "onUpdate:value": _cache[9] || (_cache[9] = $event => _ctx.activityData.activityFormData.activityDescription = $event),
      rows: 5,
      style: {
        "width": "530px",
        "margin-top": "30px"
      }
    }, null, 8, ["value"]), _createElementVNode("div", _hoisted_43, [_createVNode(_component_a_button, {
      onClick: _ctx.confirmSaveActivity,
      class: "sts-button default",
      color: "black"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.save")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      style: {
        "margin-left": "13px"
      },
      class: "sts-button default",
      onClick: _ctx.goBack
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.back")), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["model"])])])])]), _createVNode(_component_ex_dialog, {
    extraStyle: "min-width: 380px; max-width: 600px;width: 50%;padding:10px",
    isVisible: _ctx.activityData.tagDialogVisible,
    ref: "tagDialog"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_vxe_input, {
      modelValue: _ctx.activityData.tagSearchKey,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.activityData.tagSearchKey = $event),
      placeholder: _ctx.$t('activityCreate.search'),
      type: "search",
      onKeyup: _ctx.searchEvent
    }, null, 8, ["modelValue", "placeholder", "onKeyup"])]), _createElementVNode("div", _hoisted_44, [_createVNode(_component_vxe_table, {
      size: "small",
      class: "column-sort",
      ref: "tagTable",
      height: "auto",
      "loading-config": {
        icon: 'vxe-icon-indicator roll',
        text: ' '
      },
      "row-config": {
        isHover: true
      },
      data: _ctx.activityData.activityTagCacheData,
      "sort-config": {
        showIcon: false
      },
      "checkbox-config": {
        checkStrictly: true
      },
      onHeaderCellClick: _ctx.headerCellClickEvent,
      "edit-config": {
        trigger: 'manual',
        mode: 'row'
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" > "), _createVNode(_component_vxe_column, {
        type: "checkbox",
        width: "50"
      }), _createVNode(_component_vxe_column, {
        field: "activityTagNameZh",
        title: _ctx.$t('activityCreate.tag'),
        sortable: "",
        "edit-render": {}
      }, {
        header: _withCtx(({
          column
        }) => [_createElementVNode("span", _hoisted_45, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
          class: _normalizeClass(["table-sort", {
            'is-order': column.order
          }]),
          iconName: "sort",
          iconSize: "24px"
        }, null, 8, ["class"])]),
        edit: _withCtx(({
          row
        }) => [_createVNode(_component_vxe_input, {
          modelValue: row.activityTagNameZh,
          "onUpdate:modelValue": $event => row.activityTagNameZh = $event,
          type: "text",
          placeholder: _ctx.$t('activityCreate.enter')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
        _: 1
      }, 8, ["title"]), _createVNode(_component_vxe_column, {
        width: "100"
      }, {
        header: _withCtx(({
          column
        }) => [_createElementVNode("span", _hoisted_46, _toDisplayString(column.title), 1)]),
        default: _withCtx(({
          row
        }) => [_createVNode(_component_a_button, {
          onClick: $event => _ctx.editRowEvent(row),
          class: "sts-button default",
          color: "black"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.edit")), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data", "onHeaderCellClick"])]), _createVNode(_component_a_button, {
      style: {
        "margin-top": "10px",
        "margin-left": "9px"
      },
      class: "sts-button default",
      circle: "",
      onClick: _ctx.addTag
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.add")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_47, [_createVNode(_component_vxe_checkbox, {
      style: {
        "font-size": "18px"
      },
      modelValue: _ctx.activityData.tagDelete,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.activityData.tagDelete = $event)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityCreate.delete")), 1)]),
      _: 1
    }, 8, ["modelValue"]), _hoisted_48, _createVNode(_component_a_button, {
      onClick: _ctx.confirmTagDialog,
      class: "sts-button default",
      color: "black"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      onClick: _cache[12] || (_cache[12] = $event => _ctx.activityData.tagDialogVisible = false),
      style: {
        "border-color": "black",
        "color": "black"
      },
      class: "sts-button default"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.cancel")), 1)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["isVisible"]), _createVNode(_component_ex_dialog, {
    extraStyle: "min-width: 380px; max-width: 808px;width: 80%",
    isVisible: _ctx.activityLogoDialogVisible
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t("activityCreate.coverCrop")), 1), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_50, [_createVNode(_component_vue_cropper, {
      ref: "logoCropper",
      img: _ctx.activityLogoCropper.img,
      "output-size": _ctx.activityLogoCropper.size,
      "output-type": _ctx.activityLogoCropper.outputType,
      info: true,
      "info-true": true,
      full: _ctx.activityLogoCropper.full,
      fixed: _ctx.activityLogoCropper.fixed,
      "fixed-number": _ctx.activityLogoCropper.fixedNumber,
      "can-move": _ctx.activityLogoCropper.canMove,
      "can-move-box": _ctx.activityLogoCropper.canMoveBox,
      "fixed-box": _ctx.activityLogoCropper.fixedBox,
      original: _ctx.activityLogoCropper.original,
      "auto-crop": _ctx.activityLogoCropper.autoCrop,
      "auto-crop-width": _ctx.activityLogoCropper.autoCropWidth,
      "auto-crop-height": _ctx.activityLogoCropper.autoCropHeight,
      "center-box": _ctx.activityLogoCropper.centerBox,
      onRealTime: _ctx.realTime,
      high: _ctx.activityLogoCropper.high,
      mode: "contain",
      "max-img-size": _ctx.activityLogoCropper.max,
      "limit-min-size": _ctx.activityLogoCropper.limitMinSize
    }, null, 8, ["img", "output-size", "output-type", "full", "fixed", "fixed-number", "can-move", "can-move-box", "fixed-box", "original", "auto-crop", "auto-crop-width", "auto-crop-height", "center-box", "onRealTime", "high", "max-img-size", "limit-min-size"])]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_a_button, {
      onClick: _ctx.getLogoCropBlobClick,
      class: "sts-button default",
      color: "black"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_a_button, {
      onClick: _cache[13] || (_cache[13] = $event => _ctx.activityLogoDialogVisible = false),
      style: {
        "border-color": "black",
        "color": "black"
      },
      class: "sts-button default wide"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityCreate.cancel")), 1)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["isVisible"])], 64);
}